import { render, staticRenderFns } from "./SamuraisSeculoXXI.vue?vue&type=template&id=2108a8f0&"
import script from "./SamuraisSeculoXXI.vue?vue&type=script&lang=js&"
export * from "./SamuraisSeculoXXI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports